import { useEffect, useState } from "react";
import PortalLayout from "@/components/PortalLayout";
import { api, BACKEND_URL } from "@/lib/api";
import { Download } from "lucide-react";
import { ReplyButton } from "@/components/ReplyThread";

export default function PortalInvoices() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/portal/invoices").then(({ data }) => setRows(data)); }, []);
  return (
    <PortalLayout subtitle="Billing" title="Your invoices">
      {rows.length === 0 && <div className="bg-white border border-stone-200 rounded-2xl p-10 text-center text-stone-500">No invoices yet.</div>}
      <div className="space-y-3">
        {rows.map((r) => (
          <div key={r.id} className="bg-white border border-stone-200 rounded-2xl p-5 flex items-center gap-4" data-testid={`inv-${r.id}`}>
            <div className="flex-1">
              <div className="flex items-center gap-3">
                <div className="editorial text-xl">{r.invoice_no || "Draft"}</div>
                <StatusBadge s={r.status}/>
              </div>
              <div className="text-sm text-stone-500 mt-1">{r.unit_label} · {r.period_label}</div>
              <div className="text-xs text-stone-500 mt-0.5">Due {r.due_date}</div>
            </div>
            <div className="text-right">
              <div className="editorial text-2xl">₹ {r.total?.toLocaleString?.() ?? r.total}</div>
              {r.paid > 0 && <div className="text-xs text-emerald-700">Paid ₹ {r.paid.toLocaleString()}</div>}
            </div>
            <a href={`${BACKEND_URL}/api/tenants/${r.tenant_id}/invoices/${r.id}/pdf`} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-stone-300 hover:bg-sand-100 px-4 py-2 text-sm">
              <Download size={14}/> PDF
            </a>
            <ReplyButton entityType="invoice" entityId={r.id} entityTitle={r.invoice_no || `Invoice ${r.unit_label}`} testid={`reply-inv-${r.id}`}/>
          </div>
        ))}
      </div>
    </PortalLayout>
  );
}
function StatusBadge({ s }) {
  const m = { Posted: "bg-amber-100 text-amber-800", Paid: "bg-emerald-100 text-emerald-800", "Partially Paid": "bg-blue-100 text-blue-800", Cancelled: "bg-red-100 text-red-800", Overdue: "bg-red-100 text-red-800" };
  return <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${m[s] || "bg-stone-100"}`}>{s}</span>;
}
